
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/purchase",
      function () {
        return require("private-next-pages/visitor/purchase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visitor/purchase"])
      });
    }
  